import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Tooltip } from '@mui/material';
import LoadingError from './LoadingError';
import axios from '../utils/axiosInstance';
import Layout from './Layout';

const OrgDetail = () => {
  const { orgId } = useParams();
  const [orgData, setOrgData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/tables/org/${orgId}`, {
          withCredentials: true, // Important to include credentials
        });
  
        setOrgData(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Axios error:", error);
        setError(error);
        setLoading(false);
      }
    };
  
    fetchData();
  }, [orgId]);

  const { organization, issues } = orgData || {};

  return (
    <Layout role={null}> 
      <Box sx={{ padding: 2, display: 'flex', flexDirection: 'row', gap: 2}}> 
        <LoadingError isLoading={loading} error={error} />
        
        {organization && organization.length > 0 && (
          <Paper sx={{ padding: 3, flex: 1, maxWidth: '33%', marginLeft: '20px' }}> {/* Increase marginLeft slightly */}
            <Typography variant="h5" gutterBottom>
              Organization Details
            </Typography>
            <TableContainer>
              <Table>
                <TableBody>
                  {Object.keys(organization[0]).map((key) => (
                    <TableRow key={key} sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}>
                      <TableCell sx={{ maxWidth: 200 }}>
                        <Tooltip title={`Details about ${key}`} arrow>
                          <span><strong>{key}</strong></span>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={{ maxWidth: 200 }}>
                        <Tooltip title={`${organization[0][key]}`} arrow>
                          <span>{organization[0][key] || ""}</span>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        )}

        {/* Issue Table */}
        {issues && issues.length > 0 && (
          <Paper sx={{ padding: 3, flex: 2, marginLeft: '20px' }}> {/* Same margin adjustment for the issues table */}
            <Typography variant="h5" gutterBottom>
              Issue Information
            </Typography>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    {Object.keys(issues[0] || {}).map((key) => (
                      <TableCell key={key}>{key}</TableCell> // Dynamically render issue field names
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {issues.map((issue, index) => (
                    <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}>
                      {Object.keys(issue).map((key) => (
                        <TableCell key={key} sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.2 }}>
                          <Tooltip title={`${issue[key]}`} arrow>
                            <span>{issue[key] || ""}</span>
                          </Tooltip>
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        )}
      </Box>

    </Layout>
  );
};

export default OrgDetail;
